import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import Login from 'screens/login/components/index'
import signIn from './actions/signIn'
import getCsrfToken from './actions/getCsrfToken'

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
    username: state.user.username,
    error: state.error.message,
    CSRF: state.user.CSRF,
    isLoading: state.user.isLoading,
    invalidCredentials: state.user.invalidCredentials
})

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        signIn,
        getCsrfToken
    }, dispatch)
})

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Login))



// WEBPACK FOOTER //
// ./src/screens/login/index.js